import { render, staticRenderFns } from "./GestionDesarchivoList.vue?vue&type=template&id=6f7f5062&"
import script from "./GestionDesarchivoList.vue?vue&type=script&lang=js&"
export * from "./GestionDesarchivoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports